const defaults = {
    classes: 'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links ad-text adSense adBlock adContent adBanner',
    style: 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;',
};

let testNode = null;

const canRunAds = () => {
    /* eslint-disable no-undef */
    /* istanbul ignore next */
    if (typeof document === 'undefined') return true;

    if (!testNode) {
        testNode = document.createElement('div');
        testNode.innerHTML = '&nbsp;';
        testNode.setAttribute('class', defaults.classes);
        testNode.setAttribute('style', defaults.style);
        document.body.appendChild(testNode);
    }

    return !!(testNode.offsetParent !== null
        && testNode.offsetHeight
        && testNode.offsetLeft
        && testNode.offsetTop
        && testNode.offsetWidth
        && testNode.clientHeight
        && testNode.clientWidth);
    /* eslint-enable no-undef */
};

export { canRunAds };
